import it from './it';
import en from './en';

export default function translate(label, lang) {
  if (lang === 'it') return it[label];
  if (lang === 'en') return en[label];
  return 'INVALID_LANGUAGE';
}
